const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

// Observes the site header, which should have `top: -1px`, and toggles
// the `stuck` class when it hits the top of the page.
new IntersectionObserver(
  ([e]) => e.target.classList.toggle("stuck", e.intersectionRatio < 1),
  { threshold: [1] }
).observe($(`header[role="banner"]`));

const mobileMenu = $("header[role='banner']");
const buttons = $$(`[aria-controls="menu"]`);
const menu = document.getElementById("menu");

buttons.forEach(button => {
  button.addEventListener("click", event => {
    const state = button.getAttribute("aria-expanded");
    const isOpen = state === "true";

    mobileMenu.classList.toggle("menu-open");
    $("body").classList.toggle("overflow-hidden");

    // Change state for all buttons.
    buttons.forEach(button => {
      button.setAttribute("aria-expanded", isOpen ? "false" : "true");
      button.innerText = isOpen ? "menu" : "close";
    });
  });
});

$$(".isParent > button, .isGrandParent > button").forEach(button => {
  const navItem = button.parentElement;
  const otherNavItems = [...navItem.parentElement.children].filter(c=>c!=navItem);

  button.addEventListener("click", event => {
    const state = button.getAttribute("aria-expanded");
    const expanded = state === "true";
    // Reset other items.
    otherNavItems.forEach(item => {
      item.classList.remove("expanded");
      item.querySelector(":scope > button")?.setAttribute("aria-expanded", "false");
    });

    navItem.classList.toggle("expanded");
    button.setAttribute("aria-expanded", expanded ? "false" : "true");

    navItem.parentElement.classList.toggle("expanded", !expanded);

    // Toogles `expanded` class on the top menu so we can use `peer-expanded` if needed.
    if (navItem.parentElement != menu) {
      menu.classList.toggle("expanded", true);
    }
  });
});
